export default __webpack_public_path__ + "static/image6-6e3fb2d2051c8291b81b0e8c43e76ec1.png";